import { useLocation } from "react-router-dom";
import { BRAND, FOOTER, NAV } from "@/data/content";

export default function Footer() {
  const { pathname } = useLocation();
  const home = pathname === "/";
  // On subpages, hash anchors must point back to the homepage.
  const anchor = (href) => (href.startsWith("#") ? (home ? href : `/${href}`) : href);

  const companyLines = [
    FOOTER.company.ragioneSociale,
    FOOTER.company.piva,
    FOOTER.company.indirizzo,
    FOOTER.company.email,
    FOOTER.company.telefono,
    FOOTER.company.pec && `PEC: ${FOOTER.company.pec}`,
  ].filter((v) => v && !v.includes("["));

  return (
    <footer className="relative bg-brand-graphite text-brand-ivory grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex flex-col leading-none">
              <span className="font-serif text-2xl tracking-tight text-brand-ivory">{BRAND.name}</span>
              <span className="mt-1 text-[10px] uppercase tracking-editorial font-semibold text-brand-gold">
                {BRAND.division} — {BRAND.descriptor}
              </span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-brand-ivory/60">{FOOTER.tagline}</p>
            <p className="mt-6 font-serif italic text-lg text-brand-gold">{BRAND.tagline}</p>
          </div>

          <div className="lg:col-span-3">
            <span className="text-[10px] uppercase tracking-editorial font-semibold text-brand-ivory/40">Naviga</span>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a
                    href={anchor(n.href)}
                    data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-sm text-brand-ivory/70 hover:text-brand-gold transition-colors"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <span className="text-[10px] uppercase tracking-editorial font-semibold text-brand-ivory/40">Legale</span>
            <ul className="mt-5 space-y-3">
              {FOOTER.legal.map((l) => (
                <li key={l.label}>
                  <a
                    href={anchor(l.href)}
                    data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-sm text-brand-ivory/70 hover:text-brand-gold transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <span className="text-[10px] uppercase tracking-editorial font-semibold text-brand-ivory/40">Social</span>
            <ul className="mt-5 space-y-3">
              {FOOTER.social.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="text-sm text-brand-ivory/70 hover:text-brand-gold transition-colors"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-brand-ivory/10 grid gap-3 sm:grid-cols-2 text-xs text-brand-ivory/45">
          {companyLines.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>

        <p className="mt-8 text-xs text-brand-ivory/35">
          © {new Date().getFullYear()} {BRAND.name} — {BRAND.division}. Tutti i diritti riservati.
        </p>
      </div>
    </footer>
  );
}
